import { createSelector } from "reselect";
import { State } from "../reducers/root";

export const getOffices = (state: State, doctor_id: number) => {
  return state.offices.data.filter((office) => office.doctor.id === doctor_id && office.status === 0);
};

export const doctorOfficeSelector = createSelector([getOffices], (offices) => {
  return offices;
});
